import '#Client/baseline.plain.css';

import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
// import {loadStripe} from '@stripe/stripe-js';
import React from 'react';
import {render} from 'react-dom';

import {App} from '#Client/components/App/App';
import {SavedDataProvider} from '#Client/context/SavedData';
import {getSavedData, isUserNew} from '#Common/savedData';

Sentry.init({
  dsn: 'https://c4e5e046f8be4a36a82746d2bef5ad4e@o1123717.ingest.sentry.io/6161862',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== 'development',
});

// const stripePromise = loadStripe(
//   'pk_test_51MuNbkFErOcgVYdY7XUnUaFRfbTiSrVI5CyVw5va5W51pQO1K2HPQhvUt4LHMkHlNMPMnmrsZ0LStSTrTo1EHXEV00rHQyr6tn',
//   // 'pk_live_51MuNbkFErOcgVYdYi5dy2IEG3GIhgFw5VkSjpr9w1TDLJcNwSUXiWMDzHJZQKaush0w4Fl04oWZsx1peOC6I1R1300AWxpxQPQ',
// );

const orderPaymentIntentClientSecret =
  new URLSearchParams(window.location.search).get(
    'payment_intent_client_secret',
  ) || undefined;

(async () => {
  const isNew = await isUserNew(); // this must be called before getSavedData()
  const savedData = await getSavedData();
  render(
    <SavedDataProvider data={savedData} isUserNew={isNew}>
      <App
        orderPaymentIntentClientSecret={orderPaymentIntentClientSecret}
        // stripePromise={stripePromise}
      />
    </SavedDataProvider>,
    document.getElementById('root'),
  );
})();
